export class LayoutUtil {

    public static isRectsSame(rect1?: DOMRect, rect2?: DOMRect): boolean {

        if (!rect1 || !rect2) return false;

        if (rect1.left != rect2.left || rect1.top != rect2.top || rect1.width != rect2.width || rect1.height != rect2.height) return false;

        return true;
    }
}